import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import OrderCard from "../../pages/AdminPicker/SubComponent/OrderCard";
import { Modal } from "antd";
import { RiFileHistoryLine } from "react-icons/ri";
class MedicineLog extends React.Component {
  state = {
    showLog: false,
  };
  render() {
    return (
      <div>
        <button
          className="bbtn"
          onClick={() => this.setState({ showLog: true })}
        >
          <RiFileHistoryLine />
          {`View ${this.props.type === 1 ? "Picker" : "Checker"} Orders`}
        </button>
        <Modal
          title={`${this.props.type === 1 ? "Picker" : "Checker"} Log Details`}
          visible={this.state.showLog}
          onCancel={() => this.setState({ showLog: false })}
          footer={null}
          bodyStyle={{ "max-height": "80vh", "overflow-y": "auto" }}
        >
          <div>
            {this.props.type === 1
              ? this.props.pickerLog.map((e, i) => (
                  <div>
                    <OrderCard details={e} ind={i} type={2} />
                  </div>
                ))
              : this.props.type === 2
              ? this.props.checkerLog.map((e, i) => (
                  <div>
                    <OrderCard details={e} ind={i} type={2} />
                  </div>
                ))
              : null}
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  pickerLog: state.MedicineLogReducer?.pickerLog,
  checkerLog: state.MedicineLogReducer?.checkerLog,
});

export default withRouter(connect(mapStateToProps, {})(MedicineLog));
